export interface NavLink {
  label: string;
  href: string;
  external?: boolean;
}

export const MORE_LABEL = 'Ещё…';

export const HOT_TOURS_LINK: NavLink = { label: 'Горящие туры', href: '/tury' };
export const HOTELS_SEARCH_LINK: NavLink = { label: 'Поиск отелей', href: '/hotels/search' };
export const TOURS_SEARCH_LINK: NavLink = { label: 'Поиск туров', href: '/search' };
export const RUSSIA_LINK: NavLink = { label: 'Отдых в России', href: '/russia' };
export const AGENCIES_LINK: NavLink = {
  label: 'Турагентствам',
  href: 'https://travelata-promo.ru/travelata-for-agencies',
  external: true,
};

export const ABOUT_LINK: NavLink = { label: 'О нас', href: '/about' };
export const FRANCHISING_LINK: NavLink = { label: 'Франчайзи', href: '/franchising' };
export const RATING_LINK: NavLink = { label: 'Рейтинг туроператоров', href: '/rating' };
export const EARLY_BOOKING_LINK: NavLink = { label: 'Раннее бронирование', href: '/earlybooking' };
export const HOTELS_LINK: NavLink = { label: 'Все отели', href: '/hotels' };
export const RAILWAYS_SEARCH_LINK: NavLink = { label: 'ЖД туры по России', href: '/railways/search' };
export const CALENDAR_LINK: NavLink = { label: 'Календарь низких цен', href: '/calendar' };
export const WEEKEND_TOURS_LINK: NavLink = { label: 'Туры на выходные', href: '/weekend-tours/russia' };
export const SKI_LINK: NavLink = { label: 'Горнолыжные', href: '/ski' };
export const KIDS_LINK: NavLink = { label: 'Отдых с детьми', href: '/kids' };
export const NEWYEAR_TOURS_LINK: NavLink = { label: 'Туры на Новый год', href: '/newyear-tours' };
export const PAYMENT_LINK: NavLink = { label: 'Оплата', href: '/sposoby-oplaty' };
export const BLOG_LINK: NavLink = { label: 'Блог', href: '//travelata.ru/blog/' };
export const PRESS_LINK: NavLink = { label: 'Пресса о нас', href: '/press.html' };
export const GIFT_CERTIFICATES_LINK: NavLink = {
  label: 'Подарочные сертификаты',
  href: 'https://gift.travelata.ru/?utm_source=travelata&utm_medium=menu&utm_campaign=gift_certificates&utm_content=header',
};
export const FAQ_LINK: NavLink = { label: 'Частые вопросы', href: '/faq/ru' };

export const PRIMARY_NAV_LINKS: NavLink[] = [
  HOT_TOURS_LINK,
  HOTELS_SEARCH_LINK,
  TOURS_SEARCH_LINK,
  RUSSIA_LINK,
  AGENCIES_LINK,
];

export const MORE_NAV_LINKS: NavLink[] = [
  ABOUT_LINK,
  FRANCHISING_LINK,
  RATING_LINK,
  EARLY_BOOKING_LINK,
  HOTELS_LINK,
  RAILWAYS_SEARCH_LINK,
  CALENDAR_LINK,
  WEEKEND_TOURS_LINK,
  SKI_LINK,
  KIDS_LINK,
  NEWYEAR_TOURS_LINK,
  PAYMENT_LINK,
  BLOG_LINK,
  PRESS_LINK,
  GIFT_CERTIFICATES_LINK,
  FAQ_LINK,
];

export const INDEX_PRIMARY_NAV_LINKS: NavLink[] = [
  HOT_TOURS_LINK,
  HOTELS_SEARCH_LINK,
  TOURS_SEARCH_LINK,
  RUSSIA_LINK,
  ABOUT_LINK,
  AGENCIES_LINK,
  FAQ_LINK,
];

export const INDEX_MORE_NAV_LINKS: NavLink[] = [
  FRANCHISING_LINK,
  RATING_LINK,
  EARLY_BOOKING_LINK,
  HOTELS_LINK,
  RAILWAYS_SEARCH_LINK,
  CALENDAR_LINK,
  WEEKEND_TOURS_LINK,
  SKI_LINK,
  KIDS_LINK,
  NEWYEAR_TOURS_LINK,
  PAYMENT_LINK,
  BLOG_LINK,
  PRESS_LINK,
  GIFT_CERTIFICATES_LINK,
];
